module.exports = __webpack_public_path__ + "static/media/Nitika_2.23971091.png";